import { forwardRef, useState } from 'react';
import { FormCheck } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setAlert, setCategories } from '../../../redux/actions';
import AlertConfirmModal from '../AlertConfirmModal';

const Item = forwardRef(({
    category,
    selectedCategories = [],
    setSelectedCategories,
    activeCategory,
    setActiveCategory,
    setShowForm,
    categories,
}, ref) => {
    const dispatch = useDispatch();

    const [showConfirm, setshowConfirm] = useState(false);

    const handleCategoryChange = (id) => {
        let tmp = [...selectedCategories];
        if (selectedCategories.includes(id)) {
            const index = tmp.indexOf(id);
            tmp.splice(index, 1);
        } else {
            tmp.push(id);
        }

        setSelectedCategories([...tmp]);
    };

    const handleEdit = () => {
        setActiveCategory(category);
        setShowForm(true);
    };

    const handleRemove = () => {
        setshowConfirm(true);
    };

    const handleConfirm = () => {
        axios.delete(`/api/categories/${category.id}`)
            .then(response => {
                let tmp = [...categories];
                const index = tmp.findIndex(t => t.id === category.id);
                if (index >= 0) {
                    tmp.splice(index, 1);
                    dispatch(setCategories([...tmp]));
                }

                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: `${category.name} album successfully removed`
                }));
            })
            .catch(error => {
                console.error({ error });
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: `Unable to remove ${category.name} album`
                }));
            });
    };

    return (
        <div className='category' ref={ref}>
            <div className='category__name'>
                {/* <FormCheck
                    type="checkbox"
                    label={category.name}
                    checked={selectedCategories.includes(category.id)}
                    onChange={() => handleCategoryChange(category.id)}
                /> */}
                <div className='category__chck_con'>
                    <div className={`checkbox-circle${selectedCategories.includes(category.id) ? ' chck-active' : ''}`} onClick={() => handleCategoryChange(category.id)}>
                        <div
                            className="checkbox-circle-ico-con"
                            style={{
                                transform: selectedCategories.includes(category.id) ? 'scale3d(1,1,1)' : 'scale3d(0,0,0)'
                            }}
                        >
                            <i className="fa-solid fa-check"></i>
                        </div>
                    </div>
                </div>
                <div className="category__chck_lbl_con">
                    <div className='category__chck_lbl_wrapper' >
                        <div className="category__chck_lbl_name">{category.name}</div>
                        <div className="category__chck_lbl_count">{`${category.posts_count} post${category.posts_count > 1 ? 's' : ''}`}</div>
                    </div>
                    <div className="category__actions">
                        <span
                            className="px-1"
                            title="Edit"
                            onClick={handleEdit}
                        >
                            <i className="fa-regular fa-pen"></i>
                        </span>
                        <span
                            className="px-1"
                            title="Remove"
                            onClick={handleRemove}
                        >
                            <i className="fa-regular fa-trash-can"></i>
                        </span>
                    </div>
                </div>

            </div>

            <AlertConfirmModal
                modalBody={`
                    Are you sure you want to remove ${category.name}?
                `}
                show={showConfirm}
                setShow={setshowConfirm}
                isConfirm={true}
                useFunction={handleConfirm}
            />
        </div>
    );
});

const mapStateToProps = state => {
    return {
        categories: state.category.categories
    };
};

export default connect(mapStateToProps)(Item);